import React, { useEffect, useState } from "react";
import Select from "react-select";
import "./PrioritySelect.scss";
import Image from "../../image/Image";

// const options = [
//   {
//     value: "high",
//     label: "High Priority",
//     imagePath: AppIcons.High,
//     color: "#E53935",
//   },
//   {
//     value: "medium",
//     label: "Medium Priority",
//     imagePath: AppIcons.Medium,
//     color: "#F69D0B",
//   },
//   {
//     value: "low",
//     label: "Low Priority",
//     imagePath: AppIcons.Low,
//     color: "#23C55E",
//   },
// ];

const Option = ({ innerRef, innerProps, data }) => (
  <div
    ref={innerRef}
    {...innerProps}
    className="react-select__option"
    style={{ color: data.color }}
  >
    <Image
      imgCustomClassName="priority-icon"
      imagePath={data.imagePath}
      altText={data.label}
    />
    {data.label}
  </div>
);

const PrioritySelect = ({ options, initstate, onSelectionChange, id }) => {
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    if(initstate){
      setSelectedOption(initstate)
    }
  }, [initstate,options])

  const handleChange = (option) => {
    setSelectedOption(option);
    onSelectionChange(option, id)
  };

  const formatOptionLabel = ({ label, imagePath, color }) => (
    <div
      className="react-select__single-value"
      style={{ display: "flex", alignItems: "center", color }}
    >
      <Image
        imgCustomClassName="priority-icon"
        imagePath={imagePath}
        altText={label}
      />
      {label}
    </div>
  );

  return (
    <div className="priority-select">
      <Select
        options={options}
        value={selectedOption}
        components={{ Option }}
        placeholder="Select Priority"
        isSearchable={false}
        formatOptionLabel={formatOptionLabel}
        classNamePrefix="react-select"
        menuPortalTarget={document.body}
        menuPosition="absolute"
        menuPlacement="auto"
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
        onChange={handleChange}
      />
    </div>
  );
};

export default PrioritySelect;
